import { defineComponent as _defineComponent } from 'vue'
import { getPrivateRates } from "@/api/offers";
import { PrivateRate } from "@/api/types/offers";
import BaseTranslateCountry from "@/components-UI/BaseTranslateCountry.vue";
import BaseTable from "@/components-UI/table/BaseTable.vue";
import NumberCell from "@/components-UI/table/cells/NumberCell.vue";
import AffiliateIsMarked from "@/components/affiliate/AffiliateIsMarked.vue";
import { usePrivateRates } from "@/services/TablePage/private-rates";
import store from "@/store";
import { usePrivateRatesStore } from "@/store_v3/PrivateRatesStore";
import { showServerError } from "@/utils";
import { FormattedItem } from "@/utils/CellsFactory";
import { storeToRefs } from "pinia";
import { onMounted, ref, watch, watchEffect } from "vue";
import { useRoute } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivateRatesTable',
  setup(__props, { expose }) {

const { getHeaders } = usePrivateRates();
const { isNeedUpdateRates } = storeToRefs(usePrivateRatesStore());
const route = useRoute();
const isLoading = ref(false);
const items = ref<FormattedItem<PrivateRate>[]>([]);
const total = ref(0);
const offset = ref(0);
const limit = ref(100);
let ratesListRequestId = 0;

onMounted(() => {
    getRatesList();
    store.dispatch('catalogueModule/GET_DICTIONARY');
});

watch(() => route.query.columns, () => {
    getRatesList();
});

watchEffect(() => {
    if (isNeedUpdateRates.value) {
        isNeedUpdateRates.value = false;
        // Apply/Clear: всегда первая страница, иначе offset со 2+ даёт пустой ответ
        getRatesList(0);
    }
});

const getMarkingData = (marking) => {
    switch (marking) {
    case 'Маркировка': return true;
    case 'Без договора': return true;
    case 'Каталог': return false;
    case 'Рассылка': return false;
    case 'АПИ': return false;
    case 'Разработка ПО': return false;
    default: return false;
    }
};

const changePage = (offsetValue: number) => {
    offset.value = offsetValue;
    getRatesList();
};

const changeLimit = ({ offsetValue, limitValue }) => {
    offset.value = offsetValue;
    limit.value = limitValue;
    getRatesList();
};

const getRatesList = async (forcedOffset?: number) => {
    if (forcedOffset !== undefined) {
        offset.value = forcedOffset;
    }

    const requestId = ++ratesListRequestId;
    const requestOffset = forcedOffset ?? offset.value;

    try {
        isLoading.value = true;
        const params = getParams(requestOffset);
        const { data, meta } = await getPrivateRates(params);
        if (requestId !== ratesListRequestId) {
            return;
        }
        total.value = meta?.total ?? 0;
        items.value = data ?? [];
    } catch (err) {
        if (requestId !== ratesListRequestId) {
            return;
        }
        showServerError(err, 'Список приватных цен не загружен');
    } finally {
        if (requestId === ratesListRequestId) {
            isLoading.value = false;
        }
    }
};

const getParams = (requestOffset: number = offset.value) => {
    const params = { ...store.getters['GET_FILTERS_PARAMS_OBJECT'] };
    params.columns = route.query.columns;
    params.offset = requestOffset;
    params.limit = limit.value;
    return params;
};

expose({ getParams, getRatesList });

return { __sfc: true,getHeaders, isNeedUpdateRates, route, isLoading, items, total, offset, limit, ratesListRequestId, getMarkingData, changePage, changeLimit, getRatesList, getParams, BaseTranslateCountry, BaseTable, NumberCell, AffiliateIsMarked }
}

})